export default __webpack_public_path__ + "static/media/element_67.1146cf1a.webp";